import { gql } from "__generated__"

export const APPROVE_REQUEST_LEAVE = gql(`
  mutation ApproveRequestLeave($id: Int!, $status: String!) {
    approveRequestLeave(id: $id, status: $status) {
      id
      status
    }
  }
`)

export const FIND_REQUEST_LEAVES = gql(`
  query FindRequestLeaves($startDate: String, $endDate: String, $attendeeId: Int, $approverId: Int) {
    findRequestLeaves(startDate: $startDate, endDate: $endDate, attendeeId: $attendeeId, approverId: $approverId) {
      id
      action
      status
      startDate
      endDate
      reason
      note
      actionTime
      attendee {
        id
        name
        discordName
        discordId
        isPartTime
      }
      approver {
        id
        name
        discordName
        discordId
        isPartTime
      }
    }
  }
`)

export const ADD_REQUEST_LEAVE = gql(`
  mutation AddRequestLeave(
    $startDate: String!
    $endDate: String!
    $reason: String!
    $attendeeDiscordId: String!
    $approverDiscordId: String!
    $action: String!
  ) {
    addRequestLeave(
      startDate: $startDate
      endDate: $endDate
      reason: $reason
      attendeeDiscordId: $attendeeDiscordId
      approverDiscordId: $approverDiscordId
      action: $action
    ) {
      id
      action
      status
      startDate
      endDate
      reason
      note
      actionTime
      attendee {
        id
        name
        discordName
        discordId
        isPartTime
      }
      approver {
        id
        name
        discordName
        discordId
        isPartTime
      }
    }
  }
`)
